import React from 'react';

interface IconLogoProps {
  isOpen?: boolean;
}

//#6A6C6D
// const M_COLOR = '#fff';
export const IconLogo: React.FC<IconLogoProps> = ({ isOpen = true }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      enableBackground="new 0 0 30 30"
      xmlSpace="preserve"
    >
      {' '}
      <image
        id="image0"
        width="30"
        height="30"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABqCAYAAABUIcSXAAAACXBIWXMAABcRAAAXEQHKJvM/AAABe0lEQVR4nO3cMUoDURhG0T+SysYF2LuOiOtwHZYmlS5DcBsKLiWNvZVtXIHExkwunFMPvA8u87qZ1dP7zWE4d7uLpRfwN0JFCBUhVIRQEUJFCBUhVIRQEUJFCBUhVIRQEUJFCBUhVIRQEUJFCBUhVIRQEUJFCBUhVIRQEUJFCBWxnpnbpUdw1H51OPhGoMDVFyFUhFARQkUIFSFUhFARQkWsrh7etic+8+Xr+W5/7KHPy/vNzGz+e0zEx3pmHk996Mzs//DcZk6/7Wy5+iKEihAqQqgIoSKEihAqQqgIoSKEihAqQqgIoSKEihAqQqgIoSKEihAqQqgIoSKEihAqQqgIoSKEihAqYr30gN9cf79uZ2a78Iyz4Y2KECpCqAihIoSKECpCqAihIoSKWF09vPlh3/nbeaMihIoQKkKoCKEihIoQKkKoCKEihIoQKkKoCKEihIoQKkKoCKEihIoQKkKoCKEihIoQKkKoCKEihIoQKmI9M7ulR3DUxw+xehj/Xs+/zQAAAABJRU5ErkJggg=="
      />
    </svg>
  );
};
